import {
  VOUCHER_DETAILS_SUCCESS,
  VOUCHER_DETAILS_FAILED,
  RESET_VOUHCER_DETAILS,
  LOADING_VOUCHER_DETAILS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  nvalidRequest: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VOUCHER_DETAILS: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case VOUCHER_DETAILS_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case VOUCHER_DETAILS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case RESET_VOUHCER_DETAILS: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
